/* istanbul ignore next */
export function isResponseContainsKey<S extends object, E>(response: S | E, key: string): response is S {
  return key in (response as S);
}
